import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@standalone/components/icon/icon.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-deal-type',
  templateUrl: './deal-type.component.html',
  styleUrls: ['./deal-type.component.scss'],
  standalone: true,
  imports: [IconComponent, TranslocoPipe, NgIf],
})
export class DealTypeComponent {
  @Input() type!: string;
  @Input() text!: string;
  @Input() description!: string;
  @Input() disabled: boolean = false;
  @Output() typeSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() verificationSelected: EventEmitter<void> = new EventEmitter<void>();

  public get iconName(): string {
    switch (this.type) {
      case 'fast':
        return 'fire';
      case 'slow':
        return 'snowflake';
      default:
        return 'fire';
    }
  }

  public selectType(url: string): void {
    this.typeSelected.emit(url);
  }

  public redirectToVerification(): void {
    this.verificationSelected.emit();
  }
}
